import  {Stack, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, InputLabel,
  Checkbox, Button, TextField, Select, MenuItem  } from '@mui/material';
import IconCancel from '@mui/icons-material/Cancel';
import moment from 'moment';
import 'moment/dist/locale/de';

const EditProps = ({open, close, getInfo, updateChanged, states, agenten, bookingchannels}) => {

  const SelectArray = ({label, options, value, onChange}) => {
    return (
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">{label}</InputLabel>
        <Select label={label} value={value} onChange={onChange}>
          {options.map((c, k) => <MenuItem key={k} value={k}>{c}</MenuItem>)}  
        </Select>
      </FormControl>
    );
  }
  const SelectArray2 = ({label, options, value, onChange, source, idfield}) => {
    return (
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">{label}</InputLabel>
        <Select label={label} value={value} onChange={onChange}>
          {options.map((c) => <MenuItem key={c[idfield?idfield:"id"]} value={c[idfield?idfield:"id"]}>{c[source]}</MenuItem>)}  
        </Select>
      </FormControl>
    );
  }
  const updateProps = (field) => (e) => {
    updateChanged(e.target.value, field);
  }
  const updateCheckbox = (field) => (e) => {
    updateChanged(e.target.checked, field);
  }

  const updateDate = (field) => (e) => {
    updateChanged(moment(e.target.value).format('YYYYMMDD'), field);
  }

  const updateCheckReminder = (e) => {
    const value = e.target.checked ? moment().format('YYYYMMDD') : '0';
    updateChanged(value, 'erinnerung');
  }

  return (
    <>
      <Dialog open={open} onClose={close}>
        <DialogActions style={{position:'absolute', right:0}}>
          <Button label="ra.action.cancel" onClick={close}><IconCancel /></Button>
        </DialogActions>
        <DialogTitle sx={{pb:1}}>Edit dates</DialogTitle>
        <DialogContent sx={{pb:1}}>
          <Stack direction="row" spacing={2} sx={{pb:1, '& > *':{flex:1}}}>
            <SelectArray label="State" options={states} value={getInfo('status')} onChange={updateProps('status')} />
            <FormControlLabel control={<Checkbox checked={getInfo('wichtig')} onChange={updateCheckbox('wichtig')} />} label="Important" />
          </Stack>
          <SelectArray2 label="Agent" options={agenten} source="firma" idfield="id_agent" value={getInfo('id_agent')} onChange={updateProps('id_agent')} />
          <SelectArray2 label="Booking channel" options={bookingchannels} source="bezeichnung" value={getInfo('id_buchungskanal')} onChange={updateProps('id_buchungskanal')} />
          <FormControlLabel control={<Checkbox checked={getInfo('erinnerung')>0} onChange={updateCheckReminder} />} label="Reminder" />
    {getInfo('erinnerung')>0 &&
          <TextField label="Reminder date" type="date" value={moment(getInfo('erinnerung')+"").format('YYYY-MM-DD')} onChange={updateDate('erinnerung')} />
        
    }
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={close}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default EditProps;